import type { Fallacy } from "./types";
import { createStory } from "./types";

export const engagementCredibility: Fallacy = {
    id: "engagement-credibility",
    name: "Engagement = Credibility",
    emoji: "👍",
    category: "Jebakan Digital",
    description:
      "Menganggap seseorang kredibel karena **banyak followers atau likes**, padahal **popularitas bukan keahlian**.",
    tldr: "Followers banyak bukan berarti ahli — jangan samakan popularitas dengan kredibilitas.",
    detail:
      "Engagement = Credibility adalah kekeliruan di mana kita **menyamakan popularitas digital dengan keahlian atau kebenaran**. Seorang influencer dengan 5 juta followers yang bicara soal nutrisi TIDAK otomatis lebih benar daripada ahli gizi dengan 500 followers.\n\nKenyataannya: **followers bisa dibeli** (bot farms), likes bisa dimanipulasi, dan verified badge hanya berarti identitas terverifikasi — bukan kebenaran konten. Algoritma mempromosikan konten yang engaging, **bukan yang akurat**.\n\nCara melawan: **Pisahkan popularitas dari kredibilitas**. Tanyakan — apa kualifikasi orang ini di bidang yang dibahas? Apakah klaimnya didukung data?",
    story: createStory("Engagement = Credibility", "👍", {
      hook: {
        title: "Followers 4 juta vs dokter 15K.",
        body: "Siapa yang kamu percaya soal kesehatan kulit? Kalau jawabnya yang 4 juta... kita perlu ngobrol.",
      },
      convo: {
        claim: "Dokter kulit bilang skincare 10 step itu bahaya, tapi **followers-nya cuma 15K**. Influencer X punya 4 juta dan bilang aman. Jelas X yang bener.",
        response: "Followers bisa dibeli, keahlian gak bisa. **Popularitas bukan kualifikasi.**",
      },
      reveal: {
        body: "Kamu samain **popularitas digital dengan keahlian**. Padahal followers bisa dibeli, likes bisa dimanipulasi, dan algoritma promosiin yang **engaging, bukan yang akurat**.",
      },
      insight: {
        title: "Followers bukan kualifikasi",
        body: "Centang biru cuma berarti identitas terverifikasi, **bukan kebenaran kontennya**. Channel gede karena entertaining — belum tentu karena bener.",
      },
      engagement: {
        title: "Pernah lebih percaya influencer daripada ahlinya? 👍",
        body: "Soal skincare, investasi, atau diet? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["bandwagon", "appeal-to-authority", "misleading-statistics"],
  };
